import React, { useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Icon } from 'semantic-ui-react'
import ReactTable from 'react-table'
import moment from 'moment'
import { CSVLink } from 'react-csv'

import { ProcurementContainer, ProcurementBody } from 'routes/ProcurementSystem/styled'
import SearchComponent from './Shareds/Search'
import { ListContainer } from './styled'
import { getBGLimitOfBank, getBGLBPermission, getBGLBExportDate } from 'ducks/bgLimitOfBank'
import { getCompanies } from 'ducks/options'
import { getBankOwners } from 'ducks/bankGuarantee'
import { 
  bgCompanyLimitBankEditPath,
  bgCompanyLimitBankDetailPath, 
  bgCompanyLimitBankCreatePath 
} from 'routes'
import { 
  MainBodyContent, 
  CustomButton, 
  TablePagination 
} from 'components'
import {
  columnLimitOfBank,
  exportColumn
} from './AttributeData'

const BGCompanyRequest = (props) => {
  const { 
    bgLimitOfBankLists, 
    valueForm, 
    companyOptions
  } = props

  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = useState(userPageSize)

  React.useEffect(() => {
    window.scrollTo(0, 0)
    props.getBGLBPermission()
    props.getBGLimitOfBank({ page: 1, size: pageSize })
    props.getCompanies()
    props.getBankOwners()
  }, [])

  return (
    <MainBodyContent 
      headerTitle='Set up Limit of Bank'
      accessoriesHeader={
        props.permission?
        <div style={{ display: 'flex' }}>
          <CustomButton
            onClick={() => props.history.push(bgCompanyLimitBankCreatePath) }
            icon='plus'
            btnColor='gray'
            title='Add' />
          <React.Fragment>
            <CSVLink
              id='export_bgclb_link_id'
              data={props.bgclbExport}
              filename={`BGC_LimitOfBank_${moment(new Date()).format('DDMMYYYY-HHmm')}.csv`}
              headers={exportColumn}
            ></CSVLink>
            <CustomButton
              onClick={() => {
                props.getBGLBExportDate({ ...valueForm }, () => { 
                  var element = document.getElementById('export_bgclb_link_id')
                  if (element) element.click()
                })
              }}
              icon='download'
              btnColor='blue'
              title='Export Data' />
          </React.Fragment>
        </div>:null
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <SearchComponent pageSize={pageSize}/>
          <ListContainer>
            <ReactTable
              data={bgLimitOfBankLists.data ? bgLimitOfBankLists.data : []}
              columns={columnLimitOfBank}
              defaultPageSize={userPageSize}
              noDataText='No bank guarantee request data.'
              previousText={<Icon name='arrow alternate circle left' />}
              nextText={<Icon name='arrow alternate circle right' />}
              className='-striped -highlight'

              PaginationComponent={TablePagination}
              pages={bgLimitOfBankLists.totalPage ? bgLimitOfBankLists.totalPage : 0}
              currentPage={bgLimitOfBankLists.page ? bgLimitOfBankLists.page : 0}
              onPageChange={(pageIndex) => {
                props.getBGLimitOfBank({ ...valueForm, page: pageIndex + 1, size: pageSize })
              }}
              onPageSizeChange={(pageSize, pageIndex) => {
                setPageSize(pageSize)
                localStorage.setItem('userPageSize', pageSize)
                props.getBGLimitOfBank({ ...valueForm, page: pageIndex + 1, size: pageSize })
              }}

              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                    if (rowInfo && column && column.Header == 'Action') {
                      props.history.push(bgCompanyLimitBankEditPath(rowInfo.original.id))
                    }else if (rowInfo && column && column.Header !== '') {
                      props.history.push(bgCompanyLimitBankDetailPath(rowInfo.original.id))
                    }
                    if (handleOriginal) {
                      handleOriginal()
                    }
                  },
                }
              }}
            />
          </ListContainer>
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  return ({
    valueForm: getFormValues('formSearchBGLimitOfBank')(state),
    bgLimitOfBankLists: state.bgLimitOfBank.lists.data,
    companyOptions: state.options.companies,
    permission: state.bgLimitOfBank.permission,
    bgclbExport: state.bgLimitOfBank.bgclbExport.data,
  })
}

const mapDispatchToProps = {
  getBGLimitOfBank,
  getCompanies,
  getBankOwners,
  getBGLBPermission,
  getBGLBExportDate
}

const BankGuaranteeRequestForm = reduxForm({
  form: 'formSearchBGLimitOfBank',
  enableReinitialize: true,
})(BGCompanyRequest)

export default connect(mapStateToProps, mapDispatchToProps)(BankGuaranteeRequestForm)